import React, { useEffect, useState } from "react";
import "../../../assets/css/ItemVariationModal.css";
import {
  putWithAuthCall,
  simpleGetCall,
} from "../../../api/ApiServices";
import { ToastMsg } from "../../TostMsg";

const emptyVariation = () => ({
  id: "",
  item_variation_id: "",
  variation_name: "",
  variation_price: "",
  variation_rank: "",
  variation_active: "1",
  variation_group_name: "",
  quantity: "",
  variation_allow_addons: "0",
  sku_code: "",
  size: "",
  unit_of_measurement: "",
  addons: [],
});

const ItemVariationModal = ({ item, apiConfig, onClose, onRefresh ,menuId}) => {
  const [variations, setVariations] = useState([]);
  const [variantLookup, setVariantLookup] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [variantsRes] = await Promise.all([
          simpleGetCall(apiConfig.GET_ITEM_VARIANTS(item.item_id,menuId)),
          // simpleGetCall(apiConfig.GET_ITEM_LIST + item.item_id),
          // simpleGetCall(apiConfig.GET_VARIATION_LOOKUP + item.shop_id),
        ]);

        // if (lookupRes?.data) setVariantLookup(lookupRes.data);

        const rawVariations = Array.isArray(variantsRes?.data) ? variantsRes.data : [];

        const mapped = rawVariations.map((v) => ({
          id: v?.id || "",
          item_variation_id: v?.item_variation_id || "",
          variation_name: v?.variation_name || "",
          variation_price: v?.variation_price || "",
          variation_rank: v?.variation_rank || "",
          variation_active: v?.variation_active === 1 ? "1" : "0",
          variation_group_name: v?.variation_group_name || "",
          quantity: v?.quantity?.toString() || "",
          variation_allow_addons: v?.variation_allow_addon?.toString() || "0",
          sku_code: v?.sku_code || "",
          size: v?.size || "",
          is_available: v?.is_available || null,
          unit_of_measurement: v?.unit_of_measurement_id || "",
          addons: v?.addons || [],
        }));
        setVariations(mapped);
      } catch (err) {
        console.error("ItemVariationModal fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [item.item_id]);

  const handleAddRow = () => {
    setVariations((prev) => [...prev, emptyVariation()]);
  };

  const handleDeleteRow = (index) => {
    setVariations((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    setVariations((prev) =>
      prev.map((v, i) => {
        if (i !== index) return v;
        const updated = { ...v, [field]: value };
        if (field === "item_variation_id") {
          const found = variantLookup.find(
            (vl) => String(vl.id) === String(value)
          );
          updated.variation_name = found?.variation_name || "";
        }
        return updated;
      })
    );
  };

  const handleSave = () => {
    setSaving(true);
    const body = {
      variations: variations.map((v) => ({
        id: v.id,
        item_variation_id: v.item_variation_id,
        is_available: v.is_available,
        variation_price: v.variation_price,
      })),
    };

    putWithAuthCall(
      apiConfig.PUT_ITEM_VARIANTS(item.item_id, menuId),
      JSON.stringify(body)
    )
      .then((res) => {
        if (res?.success) {
          ToastMsg("success", res?.message || "Variations saved");
          onRefresh();
          onClose();
        } else {
          ToastMsg("error", res?.message || "Failed to save");
        }
      })
      .catch((err) => {
        console.error("Save variation error:", err);
        ToastMsg("error", "Something went wrong");
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="ivm-overlay" onClick={onClose}>
      <div className="ivm-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="ivm-header">
          <div className="ivm-header-left">
            <button className="ivm-close-btn" onClick={onClose} title="Close">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
            <h6 className="ivm-title">{item.item_name}</h6>
          </div>
          <button className="ivm-add-btn" onClick={handleAddRow}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z" />
            </svg>
            Add New Variation
          </button>
        </div>

        {/* Body */}
        <div className="ivm-body">
          {loading ? (
            <div className="ivm-loader">
              <div
                className="spinner-border spinner-border-sm"
                role="status"
              />
              <span>Loading variations…</span>
            </div>
          ) : (
            <>
              {variations.length > 0 && (
                <div className="ivm-col-labels">
                  <span className="ivm-col-label">Variation</span>
                  <span className="ivm-col-label">Price</span>
                  <span className="ivm-col-label ivm-col-label-center">
                    Status
                  </span>
                  <span className="ivm-col-label" />
                </div>
              )}

              {variations.length === 0 ? (
                <div className="ivm-empty">
                  No variations yet. Click "Add New Variation" to start.
                </div>
              ) : (
                variations?.map((v, index) => (
                  <div className="ivm-row" key={index}>
                    {/* Variation dropdown */}
                    <select
                      className="ivm-select"
                      value={v.item_variation_id}
                      onChange={(e) =>
                        handleChange(index, "item_variation_id", e.target.value)
                      }
                    >
                      <option value="">Select variation</option>
                      {variations?.map((vl) => (
                        <option key={vl.item_variation_id} value={vl.item_variation_id}>
                          {vl.variation_name}
                        </option>
                      ))}
                    </select>

                    {/* Price */}
                    <input
                      type="number"
                      className="ivm-price-input"
                      placeholder="Price"
                      value={v.variation_price}
                      onChange={(e) =>
                        handleChange(index, "variation_price", e.target.value)
                      }
                    />

                    {/* Status toggle */}
                    {console.log('taleeb_{v.is_available--',v)}
                    <div className="ivm-status-cell">
                      <label className="ivm-status-toggle">
                        <input
                          type="checkbox"
                          checked={v.is_available ===  true}
                          onChange={(e) =>
                            handleChange(
                              index,
                              "is_available",
                              e.target.checked ? true : false
                            )
                          }
                        />
                        <span className="ivm-toggle-slider" />
                      </label>
                    </div>

                    {/* Delete */}
                    <button
                      className="ivm-delete-btn"
                      onClick={() => handleDeleteRow(index)}
                      title="Remove variation"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path
                          fillRule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg>
                    </button>
                  </div>
                ))
              )}
            </>
          )}
        </div>

        {/* Footer */}
        <div className="ivm-footer">
          <button className="ivm-btn-close" onClick={onClose}>
            Close
          </button>
          <button
            className="ivm-btn-save"
            onClick={handleSave}
            disabled={saving || loading}
          >
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemVariationModal;
